import { render, staticRenderFns } from "./ProdutosGrade.vue?vue&type=template&id=6a3ebcfa&scoped=true"
import script from "./ProdutosGrade.vue?vue&type=script&lang=js"
export * from "./ProdutosGrade.vue?vue&type=script&lang=js"
import style0 from "./ProdutosGrade.vue?vue&type=style&index=0&id=6a3ebcfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3ebcfa",
  null
  
)

export default component.exports